<template>
  <div v-if="visivel" class="caixa-modal-overlay" @click.self="$emit('fechar')">
    <div class="caixa-modal caixa-modal--lg">
      <header class="caixa-modal__header">
        <h3>
          <i class="fas fa-lock"></i>
          Fechar Caixa
        </h3>
        <button class="caixa-modal__close" @click="$emit('fechar')">×</button>
      </header>

      <div class="caixa-modal__body">
        <div v-if="carregando" class="text-center text-muted py-3">
          <span class="spinner-border spinner-border-sm mr-1"></span>
          Calculando resumo...
        </div>

        <template v-else-if="resumo">
          <h6 class="caixa-modal__section-title">Resumo do caixa</h6>
          <table class="caixa-modal__resumo">
            <tbody>
              <tr>
                <td>Abertura</td>
                <td class="text-right">{{ brl(resumo.abertura) }}</td>
              </tr>
              <tr>
                <td>Total de vendas</td>
                <td class="text-right">{{ brl(resumo.total_vendas) }}</td>
              </tr>
              <tr v-for="(valor, forma) in resumo.vendas_por_forma" :key="forma" class="caixa-modal__resumo-sub">
                <td>&nbsp;&nbsp;{{ forma }}</td>
                <td class="text-right">{{ brl(valor) }}</td>
              </tr>
              <tr>
                <td>Total em dinheiro</td>
                <td class="text-right">{{ brl(resumo.total_dinheiro) }}</td>
              </tr>
              <tr>
                <td>Suprimentos (+)</td>
                <td class="text-right">{{ brl(resumo.suprimentos) }}</td>
              </tr>
              <tr>
                <td>Sangrias (−)</td>
                <td class="text-right">{{ brl(resumo.sangrias) }}</td>
              </tr>
              <tr class="caixa-modal__resumo-total">
                <td><strong>Valor esperado em caixa</strong></td>
                <td class="text-right"><strong>{{ brl(resumo.valor_esperado) }}</strong></td>
              </tr>
            </tbody>
          </table>

          <div class="caixa-modal__row">
            <div>
              <label class="caixa-modal__label">Valor contado</label>
              <input
                v-model.number="valorInformado"
                type="number"
                min="0"
                step="0.01"
                class="caixa-modal__input caixa-modal__input--valor"
              />
            </div>
            <div>
              <label class="caixa-modal__label">Diferença</label>
              <div class="caixa-modal__diff" :class="diffClass">{{ brl(diferenca) }}</div>
            </div>
          </div>

          <label class="caixa-modal__label">Observação</label>
          <textarea
            v-model="observacao"
            rows="2"
            class="caixa-modal__input"
            placeholder="Ex.: Diferença justificada por..."
          ></textarea>

          <p v-if="erro" class="caixa-modal__error">
            <i class="fas fa-exclamation-circle"></i> {{ erro }}
          </p>
        </template>
      </div>

      <footer class="caixa-modal__footer">
        <button class="btn btn-light" :disabled="fechando" @click="$emit('fechar')">Cancelar</button>
        <button class="btn btn-danger" :disabled="fechando || !resumo" @click="confirmar">
          <span v-if="fechando">
            <span class="spinner-border spinner-border-sm mr-1"></span>
            Fechando...
          </span>
          <span v-else>
            <i class="fas fa-lock mr-1"></i> Fechar Caixa
          </span>
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import CaixaPdvDesktopService from "@/modules/PdvDesktop/services/CaixaPdvDesktopService";

export default {
  name: "FecharCaixaModal",
  props: {
    visivel:    { type: Boolean, default: false },
    caixaAberto:{ type: Object,  default: null },
  },
  data() {
    return {
      carregando:     false,
      resumo:         null,
      valorInformado: 0,
      observacao:     "",
      erro:           "",
      fechando:       false,
    };
  },
  computed: {
    diferenca() {
      if (!this.resumo) return 0;
      return Number(this.valorInformado || 0) - Number(this.resumo.valor_esperado || 0);
    },
    diffClass() {
      const d = this.diferenca;
      if (Math.abs(d) < 0.005) return "caixa-modal__diff--ok";
      return d > 0 ? "caixa-modal__diff--sobra" : "caixa-modal__diff--falta";
    },
  },
  watch: {
    visivel(v) { if (v) this.carregar(); },
  },
  methods: {
    brl(v) {
      return Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    async carregar() {
      this.erro = "";
      if (!this.caixaAberto || !this.caixaAberto.uuid_caixa) {
        this.erro = "Caixa aberto não informado.";
        return;
      }
      this.carregando = true;
      try {
        this.resumo = await CaixaPdvDesktopService.calcularResumoCaixa(this.caixaAberto.uuid_caixa);
        this.valorInformado = this.resumo.valor_esperado;
      } catch (e) {
        this.erro = e.message || "Erro ao calcular resumo.";
      } finally {
        this.carregando = false;
      }
    },
    async confirmar() {
      this.erro = "";
      this.fechando = true;
      try {
        const reg = await CaixaPdvDesktopService.fecharCaixa({
          valor_fechamento_informado: Number(this.valorInformado) || 0,
          observacao:                 this.observacao,
        });
        if (reg && reg.impressao && reg.impressao.ok === false) {
          window.alert("Caixa fechado, mas não foi possível imprimir o comprovante. Você poderá reimprimir depois.");
        }
        this.$emit("fechado", reg);
      } catch (e) {
        this.erro = e.message || "Erro ao fechar caixa.";
      } finally {
        this.fechando = false;
      }
    },
  },
};
</script>

<style scoped>
.caixa-modal-overlay {
  position: fixed; inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex; align-items: center; justify-content: center;
  z-index: 4000;
}
.caixa-modal {
  background: #fff; border-radius: 8px;
  width: 100%; max-width: 520px;
  box-shadow: 0 12px 32px rgba(0,0,0,0.3);
  display: flex; flex-direction: column; overflow: hidden;
}
.caixa-modal--lg { max-width: 580px; }
.caixa-modal__header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 16px 20px; border-bottom: 1px solid #e5e7eb;
}
.caixa-modal__header h3 { margin: 0; font-size: 1.15rem; color: #1f2937; }
.caixa-modal__header h3 i { color: #dc2626; margin-right: 6px; }
.caixa-modal__close {
  background: transparent; border: 0; font-size: 1.6rem; cursor: pointer; color: #6b7280;
}
.caixa-modal__body { padding: 18px 20px; }
.caixa-modal__section-title { font-size: 0.85rem; color: #6b7280; text-transform: uppercase; margin: 0 0 8px; }
.caixa-modal__resumo { width: 100%; font-size: 0.92rem; }
.caixa-modal__resumo td { padding: 4px 0; border-bottom: 1px dashed #f3f4f6; }
.caixa-modal__resumo-sub td { color: #6b7280; font-size: 0.85rem; padding-left: 8px; }
.caixa-modal__resumo-total td { padding-top: 10px; border-top: 2px solid #1f2937; border-bottom: none; }
.caixa-modal__row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 14px; }
.caixa-modal__label { display: block; font-size: 0.85rem; color: #4b5563; margin: 10px 0 4px; }
.caixa-modal__input {
  width: 100%; padding: 8px 10px; border: 1px solid #d1d5db; border-radius: 6px;
  font-size: 0.95rem;
}
.caixa-modal__input--valor { font-size: 1.3rem; font-weight: 600; text-align: right; }
.caixa-modal__diff {
  margin-top: 4px; padding: 8px 10px; border-radius: 6px;
  font-size: 1.3rem; font-weight: 600; text-align: right;
  border: 1px solid #d1d5db;
}
.caixa-modal__diff--ok    { background: #ecfdf5; color: #047857; }
.caixa-modal__diff--sobra { background: #fde8e5; color: var(--primary-color, #ee7361); }
.caixa-modal__diff--falta { background: #fef2f2; color: #b91c1c; }
.caixa-modal__error { color: #b91c1c; font-size: 0.85rem; margin-top: 10px; }
.caixa-modal__footer {
  display: flex; justify-content: flex-end; gap: 8px;
  padding: 14px 20px; background: #f9fafb; border-top: 1px solid #e5e7eb;
}
</style>
